export default {
    EXW: "EXW",
    FCA: "FCA",
    FOB: "FOB",
    CFR: "CFR (CNF)",
    CIF: "CIF",
    CPT: "CPT",
    CIP: "CIP",
    DAP: "DAP",
    DPU: "DPU",
    DDP: "DDP",
}
